import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class AppHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getOpenedComplains(userId: any, branchId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/app/getOpenedComplains`, { params: { userId: userId, branchId: branchId } });
    }
}
